<template>
    <div class="placeholder" role="alert">
        <IconAlertCircle class="placeholder__icon" />
        <h3>Content Not Found</h3>
        <p>
            Either this content doesn't exist, it's been removed, or you do not have permission to
            see it.
        </p>
    </div>
</template>

<script lang="ts">
import { IconAlertCircle } from '@tabler/icons-vue';
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'ContentNotFound',

    components: {
        IconAlertCircle,
    },
});
</script>
